export const queryKeys = {
  statusList: () => ["statusList"] as const,
  topicList: () => ["topicList"] as const,
  providerDetails: (providerNpi: string) =>
    ["providerDetails", providerNpi] as const,
  queryList: (params: Record<string, unknown>) =>
    ["queryList", params] as const,
  conversationList: (params: Record<string, unknown>) =>
    ["conversationList", params] as const,
  conversationMessages: (params: Record<string, unknown>) =>
    ["conversationMessages", params] as const,
  vbcAlerts: (mrn: string) => ["vbcAlerts", mrn] as const,
  cdiAlerts: (params: Record<string, unknown>) =>
    ["cdiAlerts", params] as const,
  cdiAlertsV2: (params: Record<string, unknown>) =>
    ["cdiAlertsV2", params] as const,
  graphData: (params: Record<string, unknown>) =>
    ["graphData", params] as const,
  facilitiesList: (params: Record<string, unknown>) =>
    ["facilitiesList", params] as const,
  specialtiesList: (params: Record<string, unknown>) =>
    ["specialtiesList", params] as const,
  dashboardStartFilter: (params: Record<string, unknown>) =>
    ["dashboardStartFilter", params] as const,
  dashboardEndFilter: (params: Record<string, unknown>) =>
    ["dashboardEndFilter", params] as const,
  encounterDrg: (params: Record<string, unknown>) =>
    ["encounterDrg", params] as const,
  queryDetails: (params: Record<string, unknown>) =>
    ["queryDetails", params] as const,
  queryDetailAnswers: (params: Record<string, unknown>) =>
    ["queryDetailAnswers", params] as const,
  unreadConversationCount: (providerNpi: string) =>
    ["unreadConversationCount", providerNpi] as const,
  myQueriesOpenCount: (providerNpi: string) =>
    ["myQueriesOpenCount", providerNpi] as const,
  pdfUrl: (queryId: string) => ["pdfUrl", queryId] as const,
  htmlUrl: (queryId: string) => ["htmlUrl", queryId] as const,
  umQueriesList: (params: Record<string, unknown>) =>
    ["umQueriesList", params] as const,
  umQueryDetail: (queryId: string) => ["umQueryDetail", queryId] as const,
  umQueriesOpenCount: (providerNpi: string) =>
    ["umQueriesOpenCount", providerNpi] as const,
  opcdQueriesList: (providerNpi: string) =>
    ["opcdQueriesList", providerNpi] as const,
  opcdQueryDetail: (queryId: string, providerNpi: string) =>
    ["opcdQueryDetail", queryId, providerNpi] as const,
  opcdQueriesPendingCount: (providerNpi: string) =>
    ["opcdQueriesPendingCount", providerNpi] as const,
  opcdHimAlerts: (providerNpi: string) =>
    ["opcdHimAlerts", providerNpi] as const,
  opcdHimAlertsCount: (providerNpi: string) =>
    ["opcdHimAlertsCount", providerNpi] as const,
  opcdEncounterDateOfService: (encounterId: string) =>
    ["opcdEncounterDateOfService", encounterId] as const,
  opcdCodingAlerts: (
    providerNpi: string,
    mrn: string,
    dateOfService: string
  ) => ["opcdCodingAlerts", providerNpi, mrn, dateOfService] as const,
  opcdCodingAlertsCount: (
    providerNpi: string,
    mrn: string,
    dateOfService: string
  ) => ["opcdCodingAlertsCount", providerNpi, mrn, dateOfService] as const,
  opcdCodingResults: (
    providerNpi: string,
    mrn: string,
    dateOfService: string
  ) => ["opcdCodingResults", providerNpi, mrn, dateOfService] as const,
  careManagementQuery: (mrn: string, providerNpi: string) =>
    ["careManagementQuery", mrn, providerNpi] as const,
  clinicalCareGuidelines: (params: Record<string, unknown>) =>
    ["clinicalCareGuidelines", params] as const,
  clinicalCareGuidelineDetail: (id: string) =>
    ["clinicalCareGuidelineDetail", id] as const,
  clinicalCareGuidelineRevision: (
    id: string,
    revisionNumber: number | string
  ) => ["clinicalCareGuidelineRevision", id, String(revisionNumber)] as const,
  clinicalCareGuidelinesLookup: (conditions: string[]) =>
    ["clinicalCareGuidelinesLookup", conditions] as const,
  fhirEncounterConditions: (patientId: string, encounterId: string | null) =>
    ["fhirEncounterConditions", patientId, encounterId] as const,
  encoderCatalog: () => ["encoder", "catalog"] as const,
  encoderCodeSearch: (params: Record<string, unknown>) =>
    ["encoder", "codes", "search", params] as const,
  encoderInstructions: (codes: string[]) =>
    ["encoder", "codes", "instructions", "v3", codes.join("|")] as const,
  encoderCmYears: () => ["encoder", "cm", "years"] as const,
  encoderCmIndexSearch: (params: Record<string, unknown>) =>
    ["encoder", "cm", "index-search", params] as const,
  encoderCmIndexTree: (params: Record<string, unknown>) =>
    ["encoder", "cm", "index-tree", params] as const,
  encoderCmTable: (params: Record<string, unknown>) =>
    ["encoder", "cm", "table", params] as const,
  encoderCmTabular: (params: Record<string, unknown>) =>
    ["encoder", "cm", "tabular", params] as const,
  encoderCmTabularSearch: (params: Record<string, unknown>) =>
    ["encoder", "cm", "tabular-search", params] as const,
  encoderPcsYears: () => ["encoder", "pcs", "years"] as const,
  encoderPcsTables: (fiscalYear: number) =>
    ["encoder", "pcs", "tables", fiscalYear] as const,
  encoderPcsIndexSearch: (params: Record<string, unknown>) =>
    ["encoder", "pcs", "index-search", params] as const,
  encoderPcsDefinitionsSearch: (params: Record<string, unknown>) =>
    ["encoder", "pcs", "definitions-search", params] as const,
  encoderPcsDefinitionLookup: (params: Record<string, unknown>) =>
    ["encoder", "pcs", "definition-lookup", params] as const,
  encoderPcsCodeDescription: (params: Record<string, unknown>) =>
    ["encoder", "pcs", "code-description", params] as const,
  encoderIcdGuidelineYears: (guidelineType?: string) =>
    ["encoder", "guidelines", "icd", "years", guidelineType ?? ""] as const,
  encoderIcdGuidelineChapters: (guidelineType: string) =>
    ["encoder", "guidelines", "icd", "chapters", guidelineType] as const,
  encoderIcdGuidelineSubChapters: (params: Record<string, unknown>) =>
    ["encoder", "guidelines", "icd", "sub-chapters", params] as const,
  encoderIcdGuidelineTopics: (params: Record<string, unknown>) =>
    ["encoder", "guidelines", "icd", "topics", params] as const,
  encoderIcdGuidelineSubTopics: (params: Record<string, unknown>) =>
    ["encoder", "guidelines", "icd", "sub-topics", params] as const,
  encoderIcdGuidelineSearch: (params: Record<string, unknown>) =>
    ["encoder", "guidelines", "icd", "search", params] as const,
  encoderIcdGuidelineByIds: (ids: string) =>
    ["encoder", "guidelines", "icd", "by-ids", ids] as const,
  encoderAhaYears: () => ["encoder", "guidelines", "aha", "years"] as const,
  encoderAhaQuarters: (year: string) =>
    ["encoder", "guidelines", "aha", "quarters", year] as const,
  encoderAhaSearch: (params: Record<string, unknown>) =>
    ["encoder", "guidelines", "aha", "search", params] as const,
  encoderAhaKeywordSearches: (keywords: string[]) =>
    ["encoder", "guidelines", "aha", "keywords", keywords] as const,
  encoderAhaByIds: (ids: string) =>
    ["encoder", "guidelines", "aha", "by-ids", ids] as const,
  encoderClinicalCriteriaFiles: () =>
    ["encoder", "clinical-criteria", "files"] as const,
  encoderClinicalCriteriaFile: (id: string, name: string) =>
    ["encoder", "clinical-criteria", "file", id, name] as const,
  encoderMsdrgOptions: () => ["encoder", "msdrg", "options"] as const,
  encoderCoverageStates: () => ["encoder", "coverage", "states"] as const,
  encoderCoverage: (params: Record<string, unknown>) =>
    ["encoder", "coverage", params] as const,
  encoderFhirPrefill: (patientId: string, encounterId: string | null) =>
    ["encoder", "fhir-prefill", patientId, encounterId] as const,
};
